import { z } from "zod";

const priceType = z.enum(["RECURRING", "ONE-TIME", "BONUS"]);
// USACND is legacy, but API can't remove it so we have to keep it to avoid contract errors
const zone = z.enum(["EU", "STD", "EXO", "HT", "BREXIT", "USACND"]);

const price = z.object({
  amount: z.number().optional(),
  currencyCode: z.string().optional(),
});

const offer = z.object({
  id: z.string(),
  productOfferingPrice: z
    .object({
      priceType,
      price,
    })
    .optional(),
  balances: z
    .array(
      z.object({
        balanceId: z.string(),
        grantValue: z.string().optional(),
      }),
    )
    .optional(),
  category: z.string().optional(),
  visibility: z.boolean().optional(),
  productSpecificationType: z.string().optional(),
  productSpecificationId: z.string().optional(),
  zone: zone.optional(),
  refillPeriod: z.number().optional(),
});

export const serverResponse = z.array(offer);
export type IOffer = z.infer<typeof offer>;
export type IOfferZone = z.infer<typeof zone>;
